<template>
    <vue-good-table
        styleClass="vgt-table bordered"
        theme="polar-bear"
        :line-numbers="true"
        :columns="columns"
        :rows="data"
        :search-options="{
            enabled: true,
            externalQuery: searchTerm
        }"
        :pagination-options="{
            enabled: true,
            perPage:pageLength
        }"
        class="com-details mb-50"
    >
        <template
            slot="table-row"
            slot-scope="props"
        >
            <span v-if="props.column.field === 'description'">
                <p class="column-desc">{{ props.row.commodity.description }}</p>
            </span>
        </template>
      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import {
  BPagination,
  BFormSelect,
} from "bootstrap-vue";
export default {
    name: "BookingCommodity",
    components: {
        VueGoodTable,
        BPagination,
        BFormSelect,
    },
    props: {
        data: Array
    },
    data() {
        return {
            pageLength: 3,
            rows: [],
            searchTerm: '',
            columns: [
                {
                    width: "150px",
                    label: "Title",
                    field: 'commodity.title',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "400px",
                    label: "Description",
                    field: 'description',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Temperature Control",
                    field: 'commodity.requiresTemperatureControl',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Temperature",
                    field: 'commodity.temperatureControl',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Special Equipment",
                    field: 'commodity.requiresSpecialEquipment',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Height",
                    field: 'commodity.specialEquipment.height',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Width",
                    field: 'commodity.specialEquipment.width',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Length",
                    field: 'commodity.specialEquipment.length',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Dangerous Cargo",
                    field: 'commodity.dangerousCargo',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Classe",
                    field: 'commodity.commodityClass',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "UN",
                    field: 'commodity.commodityUn',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                }
            ]
        }
    }
}
</script>

<style>
.com-details .vgt-table.polar-bear td {
  padding: .60em 0 .60em 0 !important;
  text-align: center;
  vertical-align: middle !important;
}
.column-desc {
    padding-left: 10px;
    text-align: left !important;
    max-height: 120px;
    overflow-y: auto;
    margin-bottom : 0 !important
}
</style>